exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".g2dKbRcYdSWgy56eRjDgu ._17BdGRhgn9nlF18380sclo{margin:0 0 40px 0}.g2dKbRcYdSWgy56eRjDgu ._2cOvC5ljFQjGP7TgkwUsO6{width:400px;max-width:100%;padding:20px;border:1px solid #e8e8e8;border-radius:4px;margin:0 0 40px 0}\n", ""]);

// Exports
exports.locals = {
	"Buttons": "g2dKbRcYdSWgy56eRjDgu",
	"demo": "_17BdGRhgn9nlF18380sclo",
	"demoBlock": "_2cOvC5ljFQjGP7TgkwUsO6"
};